import React, { useState, useRef, useEffect } from 'react';
import './SearchBar.scss';
import { SEARCH_BAR } from '../../mock/lang/generalTranslations';
import { IoSearch } from 'react-icons/io5';
import { RiCloseLargeFill } from 'react-icons/ri';
import locales from '../../assets/const/locales';
import { useCurrentLocale } from 'widget-shared-components-library';
import NoResults from '../../../src/assets/images/no_results.png';

import SearchInput from './components/SearchInput';
import DefaultLayout from './components/DefaultLayout';
import SectionsLayout from './components/SectionsLayout';


const positionResults = (mobile, searchbarRef, inputRef, hasScrolled) => {
    if (!mobile && searchbarRef) {
        const rect = searchbarRef.getBoundingClientRect();
        return {
            position: 'fixed',
            top: `${rect.bottom}px`,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1000,
            backgroundColor: 'white',
            overflowY: 'auto',
            padding: '20px'
        };
    } else if (inputRef) {
        const rect = inputRef.offsetTop +inputRef. offsetHeight;
        const offset = window.innerWidth > 990 ?( !hasScrolled ? 79 : 42 ): (!hasScrolled ? 40 :18);

        return {
            position: 'fixed',
            top: `${rect + offset}px`,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1000,
            backgroundColor: 'white',
            overflowY: 'auto',
            padding: '20px'
        };
    }
    return null
};

const SearchBar = ({ mobile = false }) => {
    const [query, setQuery] = useState('');
    const [suggestion, setSuggestion] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [isListening, setIsListening] = useState(false);
    const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);
    const recognitionRef = useRef(null); // Use ref to track recognition instance
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const inputRef = useRef(null); // Reference for the input field
    const [apiData, setApiData] = useState(null); // State to store fetched data
    const [isLoading, setIsLoading] = useState(false);
    const [isInitialized, setIsInitialized] = useState(false);
    const [debouncedQuery, setDebouncedQuery] = useState('');
    const debounceTimeout = useRef(null);
    const [recentSearchesList, setRecentSearchesList] = useState(
        JSON.parse(sessionStorage.getItem('recentSearchesList'))
    );
    const [suggestionsList, setSuggestionsList] = useState([]);
    const localHost = 'http://localhost:8080';
    const isLocalEnv = process.env.NODE_ENV === 'development';
    const origin = process.env.REACT_APP_SEARCH_SUPPORT_ORIGIN_URL;
    const originUrlRedirection =
        isLocalEnv || window.location.origin.includes("my.cosmote")
            ? "https://www.telekom.gr"
            :  window.location.origin.includes("myuat.cosmote")
                ?  "https://uatatg.telekom.gr"
                :  window.location.origin.includes("mysit.cosmote")
                    ?  "https://sitatg.telekom.gr"
                    :   window.location.origin;
    const baseUrl = isLocalEnv ? localHost : origin;

    const lang = useCurrentLocale();

    const landingUrl =
        baseUrl +
        (lang === locales.ENGLISH || lang === 'En' || lang === 'EN'
            ? '/search-hub/search?lang=en'
            : '/search-hub/search?lang=el');

    const typeaheadUrl =
        baseUrl +
        (lang === locales.ENGLISH || lang === 'En' || lang === 'EN'
            ? '/search-hub/searchWithParameters?lang=en&q={query}'
            : '/search-hub/searchWithParameters?lang=el&q={query}');

    //const originUrlRedirection = baseUrl;

    const dropdownRef = useRef(null); // Ref for the dropdown
    const [isHovered, setIsHovered] = useState(false); // State to track hover
    const searchbarRef = useRef(null); // Ref for the search bar

    const [hasScrolled, setHasScrolled] = useState(false);

    const [defaultImgUrl, setDefaultImgUrl] = useState(null);
    const strapiUrl =
        window.location.origin.includes("my.cosmote")
        || window.location.origin.includes("my.telekom")
        || window.location.origin.includes("www.cosmote")
        || window.location.origin.includes("www.telekom")
            ? "https://content.cosmote.gr"
            : "https://uatcontent.cosmote.gr";

    // const [latestApiData, setLatestApiData] = useState(null);

    const fetchDefaultImgUrl = async () => {

        const endpoint = "/api/cosmote-banners?locale={lang}&populate%5BBanner%5D%5Bpopulate%5D=image&filters%5Bsection%5D%5B$eq%5D=search-dropdown"
        try {
            const response = await fetch(strapiUrl + endpoint.replace("{lang}",lang));
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setDefaultImgUrl(data?.data?.[0]?.attributes?.Banner?.[0]?.image?.data?.[0]?.attributes?.url);
        } catch (error) {
            console.error('Fetch error:', error);

        }
    }


    const fetchData = async (endpoint) => {
        setIsLoading(true);
        // const endpointPath = isLocalEnv ? `${endpoint}` : `${originUrlRedirection}${endpoint}`;
        const endpointPath = `${originUrlRedirection}${endpoint}`;

        try {
            const response = await fetch(endpointPath);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setApiData(data);
            const sanitizedList = data?.autocomplete?.map((item) =>
                item.replace(/<em>/g, '').replace(/<\/em>/g, '')
            );
            setSuggestionsList(sanitizedList || []);
        } catch (error) {
            console.error('Fetch error:', error);
            setApiData(null);
            setSuggestionsList([]);
        } finally {
            setIsLoading(false);
        }

    };

    useEffect(()=> {
        autocomplete(query);
    },[apiData]);

    //
    // // Save the latest loaded apiData
    // useEffect(() => {
    //     if (!isLoading && apiData) {
    //         setLatestApiData(apiData);
    //     }
    // }, [isLoading, apiData]);

    const handleInputChange = (e) => {
        const value = e.target.value;
        setQuery(value);

        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }
        debounceTimeout.current = setTimeout(() => {
            setDebouncedQuery(value);
        }, 300);

      autocomplete(value);
    };

    const autocomplete = (value) => {
        const match = suggestionsList?.find((item) =>
            item.toLowerCase().startsWith(value.toLowerCase())
        );
        setSuggestion(match ? match : '');
    }

    // Fetch data when the search bar is clicked and empty
    const handleInputFocus = () => {
        setIsFocused(true);
        setHover(false);
        if (!query) {
            fetchDefaultImgUrl();
            fetchData(landingUrl);
        }
    };

    const viewAllRedirection = (type) => {
        const shopResultsUrl =
            '/eshop/searchHubResults.jsp?q={query}&selectedTabOption={selectedTabOption}';
        const tabOptions = {
            support: 'support',
            articles: 'articles',
            products: 'products',
            rateplans: 'rateplans',
        };
        const selectedTabOption = tabOptions[type] || 'products';
        const finalUrl =
            originUrlRedirection +
            shopResultsUrl
                .replace('{query}', query)
                .replace('{selectedTabOption}', selectedTabOption);

        window.location.href = finalUrl;
    };

    // Function to handle voice recognition
    const handleVoiceInput = () => {
        if (!('webkitSpeechRecognition' in window)) {
            return;
        }

        if (!recognitionRef.current) {
            recognitionRef.current = new window.webkitSpeechRecognition();
            recognitionRef.current.lang = lang === 'en' ? 'en-US' : 'el-GR';
            recognitionRef.current.interimResults = false;

            recognitionRef.current.onstart = () => {
                setIsListening(true);
            };

            recognitionRef.current.onresult = (event) => {
                const speechResult = event.results[0][0].transcript;
                setQuery(speechResult); // Set the recognized text to the input
                // Explicitly trigger suggestions after voice input
                setTimeout(() => {
                    handleInputChange({target: {value: speechResult}});
                }, 0); // Ensures that setQuery completes first
            };

            recognitionRef.current.onerror = (event) => {
                console.error('Speech recognition error:', event.error);
                setIsListening(false);
            };

            recognitionRef.current.onend = () => {
                setIsListening(false);
            };
        }

        // If recognition is already running, stop it
        if (recognitionRef.current && isListening) {
            recognitionRef.current.stop();
            setIsListening(false);
        } else {
            // Start recognition if not already listening
            recognitionRef.current.start();
            setIsListening(true);
        }
    };

    const highlightMatchedText = (text, query) => {
        if (!query) return text;

        const parts = text.split(new RegExp(`(${query})`, 'gi'));

        return (
            <>
                {parts.map((part, index) =>
                    part.toLowerCase() === query.toLowerCase() ? (
                        <span key={index} style={{ color: '#004B87' }}>
                            {part}
                        </span>
                    ) : (
                        part
                    )
                )}
            </>
        );
    };



    const translation = (code) => {
        return SEARCH_BAR?.[code][lang === 'en' ? 'en' : 'gr'];
    };

    const handleProductClick = (product) => {
        const url = product?.productUrl;
        if (url) {
            window.location.href = originUrlRedirection + url;
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'ArrowRight' && suggestion) {
            setQuery(suggestion);
            setSuggestion('');
        } else if (e.key === 'Enter' && isFocused && query.trim()) {
            e.preventDefault();
            if (!recentSearchesList) {
                setRecentSearchesList([]);
            }
            const index = recentSearchesList?.indexOf(query);
            if (recentSearchesList && recentSearchesList?.length < 3 && index === -1) {
                recentSearchesList.unshift(query);
                sessionStorage.setItem('recentSearchesList', JSON.stringify(recentSearchesList));
            } else if (index === -1) {
                recentSearchesList.pop();
                recentSearchesList.unshift(query);
                sessionStorage.setItem('recentSearchesList', JSON.stringify(recentSearchesList));
            }
            let searchUrl = `${originUrlRedirection}/eshop/searchHubResults.jsp?q=${query}&selectedTabOption=products`;

             window.location.href = searchUrl;
        }
    };
    const handleSuggestionClick = () => {
        setQuery(suggestion);
        setSuggestion('');
        if (inputRef.current) {
            inputRef.current.textContent = suggestion;
            placeCaretAtEnd(inputRef.current);
        }
    };

    const placeCaretAtEnd = (el) => {
        el.focus();
        const selection = document.getSelection();
        selection.selectAllChildren(el);
        selection.collapseToEnd();
    };




    const removeSearch = (search) => {
        const updatedList = recentSearchesList.filter((item) => item !== search);
        setRecentSearchesList(updatedList);
        sessionStorage.setItem('recentSearchesList', JSON.stringify(updatedList));
    };


    const clearInput = () => {
        setQuery('');
        setSuggestion('');
        setApiData(null);
        fetchData(landingUrl);
    };

    const handleCloseDropdown = () => {
        setIsFocused(false);
        setIsMobileSearchOpen(false);
        setHasScrolled(false);
    };

    // Function to update window width
    const handleResize = () => {
        setWindowWidth(window.innerWidth);
        if (window.innerWidth > 990) {
            setIsMobileSearchOpen(false);
        }
    };

    const handleMobileSearchToggle = () => {
        setIsMobileSearchOpen(true);
        setHover(false);
        if (!isMobileSearchOpen) {
            setTimeout(() => {
                inputRef.current.focus(); // Automatically focus on the input field
            }, 100); // Small delay to ensure the input is rendered before focusing
        }
    };

    const handleClickOutside = (event) => {
        if (
            dropdownRef.current &&
            !dropdownRef.current.contains(event.target) &&
            !isHovered &&
            !searchbarRef.current.contains(event.target)
        ) {
            setIsFocused(false);
            setIsMobileSearchOpen(false);
        }
    };

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    //event listener on component mount to track window resize
    useEffect(() => {
        window.addEventListener('resize', handleResize);

        // Clean up the event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isHovered]);

    useEffect(() => {
        if (!isInitialized) {
            setIsInitialized(true);
            return;
        }
        if (debouncedQuery) {
            fetchData(typeaheadUrl.replace('{query}', debouncedQuery));
        } else {
            fetchData(landingUrl);
            setApiData(null);
            setSuggestionsList([]);
        }
    }, [debouncedQuery]);
    const [resultsStyle, setResultsStyle] = useState({});
    useEffect(() => {
        return () => {
            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
            }
        };
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            setHasScrolled(window.scrollY >= 320);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        if (isFocused || isMobileSearchOpen) {
            const styles = positionResults(mobile, searchbarRef.current, inputRef.current, hasScrolled)
            if (styles) {
                setResultsStyle(styles);
            }
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isFocused,isMobileSearchOpen]);

    useEffect(() => {
        const handler = () => {
            const styles = positionResults(mobile, searchbarRef.current, inputRef.current, hasScrolled)
            if (styles) {
                setResultsStyle(styles);
            }
        }
        window.addEventListener('scroll', handler);
        window.addEventListener('resize', handler);
        return () => {
            window.removeEventListener('scroll', handler);
            window.removeEventListener('resize', handler);
        };
    }, []);

const [hover, setHover] = useState(false);
    return (
        <div
            className={`searchbar-container ${isFocused ? 'focused' : ''}`}
            ref={searchbarRef}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={{marginRight: '20px'}}
        >
            {mobile && (
                <div
                    className="mobile-search-icon"
                    style={{ color: isMobileSearchOpen ? '#e20074' : 'black' }}
                    onClick={handleMobileSearchToggle}
                >
                    <IoSearch className="search-icon" />
                </div>
            )}

            {!mobile && (
                <SearchInput
                    query={query}
                    suggestion={suggestion}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    onFocus={handleInputFocus}
                    onClear={clearInput}
                    onVoice={handleVoiceInput}
                    isListening={isListening}
                    translation={translation}
                    inputRef={inputRef}
                    onSuggestionClick={handleSuggestionClick}
                />
            )}

            {(isFocused || isMobileSearchOpen) && (
                <div
                    className={"typeahead-dropdown-searchHub ".concat(mobile ? 'mobile' : 'desktop')}
                    style={resultsStyle}
                    ref={dropdownRef}>
                    <div style={{maxWidth: '1630px'}}>
                        <button className={hover && windowWidth > 990  ? "hover-close-button" : "close-button"}
                                onMouseEnter={() => setHover(true)}
                                onMouseLeave={() => setHover(false)}
                                onClick={handleCloseDropdown}>
                            {translation('close')} <RiCloseLargeFill />
                        </button>
                    </div>

                    {isMobileSearchOpen && (
                        <SearchInput
                            mobile
                            query={query}
                            suggestion={suggestion}
                            onChange={handleInputChange}
                            onKeyDown={handleKeyDown}
                            onFocus={handleInputFocus}
                            onClear={clearInput}
                            onVoice={handleVoiceInput}
                            isListening={isListening}
                            translation={translation}
                            inputRef={inputRef}
                            onSuggestionClick={handleSuggestionClick}
                        />
                    )}

                    {apiData && (apiData?.products || apiData?.services) && (
                        <div className="dropdown-content-searchHub">
                            {apiData && (
                                <>
                                    {query ? (
                                        <SectionsLayout
                                            apiData={apiData}
                                            translation={translation}
                                            query={query}
                                            viewAllRedirection={viewAllRedirection}
                                            originUrlRedirection={originUrlRedirection}
                                            handleProductClick={handleProductClick}
                                            handleInputChange={handleInputChange}
                                        />
                                    ) : (
                                        <DefaultLayout
                                            apiData={apiData}
                                            translation={translation}
                                            query={query}
                                            recentSearchesList={recentSearchesList}
                                            removeSearch={removeSearch}
                                            handleInputChange={handleInputChange}
                                            handleProductClick={handleProductClick}
                                            originUrlRedirection={originUrlRedirection}
                                            lang={lang}
                                            defaultImgUrl={defaultImgUrl}
                                            strapiEndpoint={strapiUrl}
                                        />
                                    )}
                                </>
                            )}
                        </div>
                    )}

                    {!isLoading && !(apiData?.products || apiData?.services) && (
                        <div className="dropdown-content-searchHub no-results-content">
                            <img src={NoResults} alt="No results" />
                            <p>{translation('noResultsFound')}</p>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default SearchBar;
